/*Clase genérica para opciones de lista */
export class Basic<keyType> {
    public code: keyType;
    public description: string;
    public active?: boolean;
}